import SidebarNavigation from "./SidebarNavigation.vue";

export * from "./routes";
export * from "./routes.types";

export default SidebarNavigation;
